import axios from "axios";
import { Message } from "element-ui";
import VueCookies from "vue-cookies";
import website from "@/config/website";
import { Base64 } from "js-base64";
import { setCookie, delCookieInfos } from "@/utils/util.js";

var HttpRequest2 = {
  getRequest({ url, data = {}, method = "GET", header, onUploadProgress }) {
    console.log(header, "headerheader");
    return new Promise((resolve, reject) => {
      this._getRequest(
        url,
        resolve,
        reject,
        data,
        method,
        header,
        onUploadProgress
      );
    });
  },

  _getRequest: function(
    url,
    resolve,
    reject,
    data = {},
    method = "GET",
    header,
    onUploadProgress
  ) {
    var token = VueCookies.get("userToken");
    var RoleId = VueCookies.get("Role-Id");
    var userInfo = localStorage.getItem("UserInfo");

    console.log(userInfo, "userInfouserInfo");
    let format =
      method.toLocaleLowerCase() === "get" ||
      method.toLocaleLowerCase() === "delete"
        ? "params"
        : "data";

    axios.defaults.headers.common = {
      Authorization: `Basic ${Base64.encode(
        `${website.clientId}:${website.clientSecret}`
      )}`,
      "Wenbo-Auth": "bearer " + token,
      "Tenant-Id": VueCookies.get("tenantId"),
      "Content-Type": "application/json; charset=UTF-8",
      "Client-Type": "WenboSaber"
    };

    axios({
      url: url,
      async: false,
      method: method,
      [format]: data,
      onUploadProgress: onUploadProgress,
      responseType: "blob"
    })
      .then(res => {
        if (res.status == 200) {
          resolve(res);
        } else {
          console.log(res, "http-error 1");
        }
      })
      .catch(res => {
        console.log(res, "http-error 2");
        reject(res);
      });
  }
};
export { HttpRequest2 };



// WEBPACK FOOTER //
// ./src/request/http2.js